import { useTheme } from '@mui/material';
import { TableV1 } from '../../../components/Table/TableV1';
import { TableContentSkeletonLoader } from './TableContentSkeletonLoader';
import { UserWithTsPeriodData } from '../../../types';
import { Row, Table } from '@tanstack/react-table';
import { OpenTimesheetApprovalTableRow } from '../../TimesheetApprovals/hooks/useAllOPLogsMapped';

interface TimesheetStatusesTableContentProps {
  table: Table<UserWithTsPeriodData> | Table<OpenTimesheetApprovalTableRow>;
  timesheetsLoading: boolean;
  getRowClassName?: (row: Row<any>) => string | undefined;
}

export function TimesheetStatusesTableContent({
  table,
  timesheetsLoading,
  getRowClassName,
}: TimesheetStatusesTableContentProps) {
  const { colors } = useTheme();

  if (timesheetsLoading) {
    return <TableContentSkeletonLoader />;
  }

  return (
    <TableV1
      table={table}
      height='auto'
      isLastColumnSticky={false}
      disableRowHover
      getRowClassName={getRowClassName}
      wrapperStyle={{
        maxHeight: 'calc(100vh - 288px)',
        overflowX: 'scroll',
        border: `1px solid ${colors.border.default}`,
        overflowY: 'scroll',
      }}
    />
  );
}
